
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Calque_1","data-name":"Calque 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 445.7 445.7"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',[_c('g',[_c('circle',{staticClass:"cls-1",attrs:{"cx":"222.85","cy":"222.85","r":"222.85"}})]),_c('g',[_c('rect',{staticClass:"cls-2",attrs:{"x":"380","y":"99.76","width":"40","height":"600","rx":"8.67","ry":"8.67","transform":"translate(-342.67 223.27) rotate(-45.05)"}}),_c('rect',{staticClass:"cls-2",attrs:{"x":"380","y":"100","width":"40","height":"600","rx":"8.67","ry":"8.67","transform":"translate(222.37 -342.83) rotate(44.95)"}})])])])
          )
        }
      }
    